import React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
import { Provider, useDispatch } from "react-redux";
import configureStore from "./store/configureStore";

const timeLimit = 10000;
const incrementValue = 100;
let time = 0;

const store = configureStore({});

const interval = setInterval(function() {
  const reactContainer = document.getElementById("react-map-app");
  if (timeLimit <= time) {
    clearInterval(interval);
  }
  if (!reactContainer) {
    time += incrementValue;
    return;
  }

  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    reactContainer
  );

  clearInterval(interval);
}, incrementValue);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
